import { styled } from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-grow: 1;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 80%;
`